/**
 * Comma-separated positive integers for sites list / search API query params.
 * @param {Array<{ value: number|string }>|null|undefined} selectedOptions
 * @returns {string} empty string when no selection (means no filter)
 */
export function serializeOptionValuesParam (selectedOptions) {
  if (!selectedOptions?.length) return ''
  return selectedOptions.map((o) => o.value).join(',')
}

/**
 * Normalizes persisted URL / provider filter values into react-select multi value shape.
 * @param {unknown} stored — null | single option | non-empty array
 * @returns {Array| null}
 */
export function normalizeSitesFilterMulti (stored) {
  if (stored == null) return null
  return Array.isArray(stored) ? (stored.length ? stored : null) : [stored]
}

/**
 * Whether the sites list should call the search API (vs plain list).
 * Short numeric site codes (1–2 digits) are allowed; text / mixed queries need ≥3 characters
 * so we do not hit the search endpoint on every keystroke for 1–2 letter prefixes.
 * @param {string} raw
 * @returns {boolean}
 */
export function isSitesListSearchQueryActive (raw) {
  const t = String(raw ?? '').trim()
  if (!t.length) return false
  if (/^\d+$/.test(t)) return true
  return t.length >= 3
}
